import React from 'react'
import SectionHeading from '../common/SectionHeading'

const ROLE_LABELS = {
    PROJECT_MANAGER: 'Project Manager',
    ACCOUNT_MANAGER: 'Account Manager',
    MERCHANDISER: 'Merchandiser',
    FASHION_DESIGNER: 'Fashion Designer',
    PRODUCT_DEVELOPMENT: 'Product Development',
    COSTING_MANAGER: 'Costing Manager',
    GARMENTS_TECH: 'Garments Tech',
    QA: 'QA',
    BUSINESS_DEVELOPMENT_MANAGER: 'Business Development Manager'
}

const MemberAvatar = ({ member }) => {
    const imgUrl = member.profilePicDocument?.docUrl
    return imgUrl ? (
        <img
            src={imgUrl}
            alt={member.name}
            className='w-8 h-8 rounded-full object-cover shrink-0'
        />
    ) : (
        <span
            className='flex items-center justify-center w-8 h-8 rounded-full text-white text-[11px] font-semibold shrink-0'
            style={{ backgroundColor: '#21242b' }}
        >
            {member.name.trim()[0].toUpperCase()}
        </span>
    )
}

const MemberRow = ({ member }) => (
    <div className='flex items-center gap-2'>
        <MemberAvatar member={member} />
        <span className='min-w-0'>
            <span className='block regular-12 weight-500 text-[#21242b] truncate'>
                {member.name}
            </span>
            <span className='block regular-12 text-[#999a9d] truncate'>
                {member.email}
            </span>
        </span>
    </div>
)

const RoleCard = ({ roleKey, members }) => (
    <div className='border border-[#e9e9ea] bg-white p-5 min-h-[128px]'>
        <p className='regular-12 weight-500 text-[#6a6c71] uppercase tracking-wide mb-3'>
            {ROLE_LABELS[roleKey] ?? roleKey}
        </p>
        {members.length > 0 ? (
            <div className='flex flex-col gap-3'>
                {members.map((member) => (
                    <MemberRow key={member.id} member={member} />
                ))}
            </div>
        ) : (
            <p className='regular-12 text-[#babbbd] italic'>
                Yet to be assigned
            </p>
        )}
    </div>
)

const TeamSection = ({ teamMembers }) => {
    const roles = teamMembers ? Object.entries(teamMembers) : []

    return (
        <section className='pt-8 pb-6'>
            <SectionHeading title='Team' />
            <p className='regular-12 text-[#999a9d] mb-3'>
                People working on your account
            </p>
            <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4'>
                {roles.map(([roleKey, members]) => (
                    <RoleCard
                        key={roleKey}
                        roleKey={roleKey}
                        members={members}
                    />
                ))}
            </div>
        </section>
    )
}

export default TeamSection
